/**
 * @generated SignedSource<<b76280ee5c2650a1221cfb85bc2eac25>>
 * @relayHash 2933432701cb330335f21f28c8e30554
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 657fd074c1c93880ebe66cca5e694d582648431d67a2ff5a78fab6939e92c8f9

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraIssueSearchAggregationFunction = "ROLLUP" | "%future added value";
export type JiraIssueSearchOperationScope = "NIN_GLOBAL" | "NIN_GLOBAL_SCHEMA_REFACTOR" | "NIN_GLOBAL_SHADOW_REQUEST" | "NIN_PROJECT" | "NIN_PROJECT_SCHEMA_REFACTOR" | "NIN_PROJECT_SHADOW_REQUEST" | "TIMELINE_PROJECT" | "%future added value";
export type JiraSoftwareIssueSearchCustomInputContext = "BACKLOG" | "BOARD" | "NONE" | "%future added value";
export type JiraIssueSearchFieldSetsInput = {
  fieldSetIds?: ReadonlyArray<string> | null | undefined;
  viewInput?: JiraIssueSearchViewInput | null | undefined;
};
export type JiraIssueSearchViewInput = {
  context?: JiraIssueSearchViewFieldSetsContext | null | undefined;
  filterId?: string | null | undefined;
  namespace?: string | null | undefined;
  viewId?: string | null | undefined;
};
export type JiraIssueSearchViewFieldSetsContext = {
  filterContext?: JiraIssueSearchViewFieldSetFilterContext | null | undefined;
  issueContext?: JiraIssueSearchViewFieldSetsIssueContext | null | undefined;
  projectContext?: JiraIssueSearchViewFieldSetsProjectContext | null | undefined;
};
export type JiraIssueSearchViewFieldSetFilterContext = {
  filter?: string | null | undefined;
};
export type JiraIssueSearchViewFieldSetsIssueContext = {
  issueKey?: string | null | undefined;
};
export type JiraIssueSearchViewFieldSetsProjectContext = {
  issueType?: string | null | undefined;
  project?: string | null | undefined;
};
export type JiraIssueSearchScope = {
  operationScope?: JiraIssueSearchOperationScope | null | undefined;
  projectKey?: string | null | undefined;
};
export type JiraIssueSearchInput = {
  childIssuesInput?: JiraIssueSearchChildIssuesInput | null | undefined;
  customInput?: JiraIssueSearchCustomInput | null | undefined;
  filterId?: string | null | undefined;
  jql?: string | null | undefined;
  searchWithLastUsedJql?: boolean | null | undefined;
};
export type JiraIssueSearchChildIssuesInput = {
  filterByProjectKeys?: ReadonlyArray<string> | null | undefined;
  filterId?: string | null | undefined;
  jql?: string | null | undefined;
  namespace?: string | null | undefined;
  parentIssueKey: string;
  viewId?: string | null | undefined;
};
export type JiraIssueSearchCustomInput = {
  jiraSoftwareInput?: JiraSoftwareIssueSearchCustomInput | null | undefined;
  jiraTimelineInput?: JiraTimelineIssueSearchCustomInput | null | undefined;
};
export type JiraSoftwareIssueSearchCustomInput = {
  additionalJql?: string | null | undefined;
  context?: JiraSoftwareIssueSearchCustomInputContext | null | undefined;
  jiraEntityId: string;
};
export type JiraTimelineIssueSearchCustomInput = {
  additionalJql?: string | null | undefined;
  boardId: string;
  customFilterIds?: ReadonlyArray<string> | null | undefined;
  quickFilterIds?: ReadonlyArray<string> | null | undefined;
};
export type JiraIssueSearchOptions = {
  issueKey?: string | null | undefined;
};
export type JiraIssueSearchSettings = {
  groupBy?: string | null | undefined;
  hideDone?: boolean | null | undefined;
  hierarchyEnabled?: boolean | null | undefined;
  jql?: string | null | undefined;
};
export type JiraIssueSearchStaticViewInput = {
  aggregationConfig?: JiraIssueSearchAggregationConfigInput | null | undefined;
  isGroupingEnabled?: boolean | null | undefined;
  isHideDoneEnabled?: boolean | null | undefined;
  isHierarchyEnabled?: boolean | null | undefined;
};
export type JiraIssueSearchAggregationConfigInput = {
  aggregationFields?: ReadonlyArray<JiraIssueSearchFieldAggregationInput> | null | undefined;
  canEnableAggregation?: boolean | null | undefined;
};
export type JiraIssueSearchFieldAggregationInput = {
  aggregationFunction?: JiraIssueSearchAggregationFunction | null | undefined;
  fieldId?: string | null | undefined;
  isEnabled?: boolean | null | undefined;
};
export type JiraIssueSearchViewConfigInput = {
  staticViewInput?: JiraIssueSearchStaticViewInput | null | undefined;
  viewInput?: JiraIssueSearchViewInput | null | undefined;
};
export type JiraIssueSearchViewQueryInput = {
  projectKeyAndItemIdQuery?: JiraIssueSearchViewProjectKeyAndItemIdQuery | null | undefined;
  viewAri?: string | null | undefined;
};
export type JiraIssueSearchViewProjectKeyAndItemIdQuery = {
  cloudId: string;
  itemId: string;
  projectKey: string;
};
export type IssueNavigatorIssueSearchRefetchQuery$variables = {
  after?: string | null | undefined;
  amountOfColumns?: number | null | undefined;
  before?: string | null | undefined;
  cloudId: string;
  fieldSetsInput?: JiraIssueSearchFieldSetsInput | null | undefined;
  fieldSetsScope?: JiraIssueSearchScope | null | undefined;
  filterId?: string | null | undefined;
  first?: number | null | undefined;
  groupBy?: string | null | undefined;
  isConditionalFormattingEnabled: boolean;
  isLastUsedJqlEnabled: boolean;
  isPaginating: boolean;
  isSavedViewConditionalFormattingEnabled: boolean;
  issueSearchInput: JiraIssueSearchInput;
  last?: number | null | undefined;
  namespace?: string | null | undefined;
  options?: JiraIssueSearchOptions | null | undefined;
  projectKey?: string | null | undefined;
  projectKeys?: ReadonlyArray<string> | null | undefined;
  saveJQLToUserHistory?: boolean | null | undefined;
  scope?: JiraIssueSearchScope | null | undefined;
  settings?: JiraIssueSearchSettings | null | undefined;
  shouldQueryHasChildren: boolean;
  staticViewInput?: JiraIssueSearchStaticViewInput | null | undefined;
  viewConfigInput?: JiraIssueSearchViewConfigInput | null | undefined;
  viewId?: string | null | undefined;
  viewQueryInput?: JiraIssueSearchViewQueryInput | null | undefined;
};
export type IssueNavigatorIssueSearchRefetchQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_IssueNavigator_refetchQuery">;
};
export type IssueNavigatorIssueSearchRefetchQuery = {
  response: IssueNavigatorIssueSearchRefetchQuery$data;
  variables: IssueNavigatorIssueSearchRefetchQuery$variables;
};
({
  "isLastUsedJqlEnabled": isLastUsedJqlEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiraninlastusedjqlrelayprovider": lastUsedJql_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider": isSavedListViewTechnicalChangesEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcisfrozencolumnsenabledrelayprovidertsx": isFrozenColumnsEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcbulkopsselectallrelayprovider": isBulkOpsSelectAllEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewenabledrelayprovider": isSavedListViewEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjscissuerankingrelayprovider": isIssueRankingEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider": isJscIFCEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider": isJSCAliasChangesEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewconditionalformattingenabledrelayprovider": isSavedViewConditionalFormattingEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider": isReparentingEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcfrontierformulafieldd1relayprovider": isFormulaFieldD1Enabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcinitialisevirtualiserstatefromrelaystorerelayprovider": isInitialiseVirtualiserStateFromRelayStoreEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcmimicflatlistrsswhileuninitialisedrelayprovider": isMimicFlatlistRssWhileUninitialisedEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreducererendersrelayprovider": isJiraListReduceRerendersEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider": isJscMergedColumnEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider": isJiraItrM4Exp3Enabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider": isIframePreviewPanelInSubtasksEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider": isJiraTimelineAnalyticsHarmonizationEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider": isAtlasProjectEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider": originalEstimateEditableFixFlag_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider": isFieldsByIdRemoved_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaifetchapptypeforuserassigneerelayprovider": shouldFetchAppUserType_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider": isJiraAiAgentAvatarSingleUserPickerEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider": isNinStrikethroughResolutionUpdateEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": isNumberFieldConfigurableEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider": isPlaceholderDataEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider": isJiraConfluencePageContentEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider": isJiraTimelineRollupsTechnicalGateEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerninrelayprovider": isJiraAiAgentAvatarSingleUserPickerNINEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyprojectsrelayprovider": isGroupByProjectsEnabled_provider
} as {
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcbulkopsselectallrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcfrontierformulafieldd1relayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcgroupbyprojectsrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcinitialisevirtualiserstatefromrelaystorerelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcisfrozencolumnsenabledrelayprovidertsx: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewconditionalformattingenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerninrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiraaifetchapptypeforuserassigneerelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiralistreducererendersrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiraninlastusedjqlrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjscissuerankingrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcmimicflatlistrsswhileuninitialisedrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly isLastUsedJqlEnabled: {
    readonly get: () => boolean;
  };
});

import isAtlasProjectEnabled_provider from '@atlassian/jira-relay-provider/src/atlas-project-native-integration.relayprovider';
import isBulkOpsSelectAllEnabled_provider from '@atlassian/jira-relay-provider/src/bulk-ops-select-all.relayprovider';
import isFormulaFieldD1Enabled_provider from '@atlassian/jira-relay-provider/src/frontier-formula-field-d1.relayprovider';
import isPlaceholderDataEnabled_provider from '@atlassian/jira-relay-provider/src/goals-ssr-smart-card.relayprovider';
import isGroupByProjectsEnabled_provider from '@atlassian/jira-relay-provider/src/group-by-projects.relayprovider';
import isInitialiseVirtualiserStateFromRelayStoreEnabled_provider from '@atlassian/jira-relay-provider/src/initialise-virtualiser-state-from-relay-store.relayprovider';
import isFrozenColumnsEnabled_provider from '@atlassian/jira-relay-provider/src/is-frozen-columns-enabled.relayprovider';
import isIframePreviewPanelInSubtasksEnabled_provider from '@atlassian/jira-relay-provider/src/is-iframe-preview-panel-in-subtasks-enabled.relayprovider';
import isJiraItrM4Exp3Enabled_provider from '@atlassian/jira-relay-provider/src/is-jira-itr-m4-exp-3-enabled.relayprovider';
import isJscIFCEnabled_provider from '@atlassian/jira-relay-provider/src/is-jsc-ifc-enabled.relayprovider';
import isSavedViewConditionalFormattingEnabled_provider from '@atlassian/jira-relay-provider/src/is-saved-list-view-conditional-formatting-enabled.relayprovider';
import isSavedListViewEnabled_provider from '@atlassian/jira-relay-provider/src/is-saved-list-view-enabled.relayprovider';
import isSavedListViewTechnicalChangesEnabled_provider from '@atlassian/jira-relay-provider/src/is-saved-list-view-technical-changes-enabled.relayprovider';
import isFieldsByIdRemoved_provider from '@atlassian/jira-relay-provider/src/issue-view-dfo-remove-fields-by-id.relayprovider';
import isJiraAiAgentAvatarSingleUserPickerNINEnabled_provider from '@atlassian/jira-relay-provider/src/jira-ai-agent-avatar-single-user-picker-nin.relayprovider';
import isJiraAiAgentAvatarSingleUserPickerEnabled_provider from '@atlassian/jira-relay-provider/src/jira-ai-agent-avatar-single-user-picker.relayprovider';
import shouldFetchAppUserType_provider from '@atlassian/jira-relay-provider/src/jira-ai-fetch-apptype-for-user-assignee.relayprovider';
import isJiraConfluencePageContentEnabled_provider from '@atlassian/jira-relay-provider/src/jira-confluence-page-content-enabled.relayprovider';
import isJiraListReduceRerendersEnabled_provider from '@atlassian/jira-relay-provider/src/jira-list-reduce-rerenders.relayprovider';
import isReparentingEnabled_provider from '@atlassian/jira-relay-provider/src/jira-list-reparenting.relayprovider';
import isLastUsedJqlEnabled_provider from '@atlassian/jira-relay-provider/src/jira-nin-last-used-jql.relayprovider';
import lastUsedJql_provider from '@atlassian/jira-relay-provider/src/jira-nin-last-used-jql.relayprovider';
import isNumberFieldConfigurableEnabled_provider from '@atlassian/jira-relay-provider/src/jira-number-field-configuration-enabled.relayprovider';
import originalEstimateEditableFixFlag_provider from '@atlassian/jira-relay-provider/src/jira-original-estimate-editable-fix.relayprovider';
import isJiraTimelineAnalyticsHarmonizationEnabled_provider from '@atlassian/jira-relay-provider/src/jira-timeline-analytics-harmonization.relayprovider';
import isJiraTimelineRollupsTechnicalGateEnabled_provider from '@atlassian/jira-relay-provider/src/jira-timeline-rollups-technical-gate.relayprovider';
import isJSCAliasChangesEnabled_provider from '@atlassian/jira-relay-provider/src/jsc-alias-changes.relayprovider';
import isIssueRankingEnabled_provider from '@atlassian/jira-relay-provider/src/jsc-issue-ranking.relayprovider';
import isJscMergedColumnEnabled_provider from '@atlassian/jira-relay-provider/src/jsc-merged-column.relayprovider';
import isMimicFlatlistRssWhileUninitialisedEnabled_provider from '@atlassian/jira-relay-provider/src/mimic-flatlist-rss-while-uninitialised.relayprovider';
import isNinStrikethroughResolutionUpdateEnabled_provider from '@atlassian/jira-relay-provider/src/nin-resolution-strikethough-enabled.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "amountOfColumns"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "before"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fieldSetsInput"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fieldSetsScope"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filterId"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "groupBy"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isConditionalFormattingEnabled"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isLastUsedJqlEnabled"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isPaginating"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isSavedViewConditionalFormattingEnabled"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "issueSearchInput"
},
v14 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "last"
},
v15 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "namespace"
},
v16 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "options"
},
v17 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectKey"
},
v18 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectKeys"
},
v19 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "saveJQLToUserHistory"
},
v20 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "scope"
},
v21 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "settings"
},
v22 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldQueryHasChildren"
},
v23 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "staticViewInput"
},
v24 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "viewConfigInput"
},
v25 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "viewId"
},
v26 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "viewQueryInput"
},
v27 = {
  "kind": "Variable",
  "name": "projectKey",
  "variableName": "projectKey"
},
v28 = {
  "kind": "Variable",
  "name": "issueSearchInput",
  "variableName": "issueSearchInput"
},
v29 = {
  "kind": "Variable",
  "name": "scope",
  "variableName": "scope"
},
v30 = {
  "kind": "Variable",
  "name": "settings",
  "variableName": "settings"
},
v31 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v32 = {
  "kind": "ScalarField",
  "name": "message"
},
v33 = [
  {
    "kind": "LinkedField",
    "name": "extensions",
    "plural": true,
    "selections": [
      (v31/*: any*/),
      {
        "kind": "ScalarField",
        "name": "statusCode"
      }
    ]
  },
  (v32/*: any*/)
],
v34 = {
  "kind": "ScalarField",
  "name": "id"
},
v35 = {
  "kind": "Variable",
  "name": "scope",
  "variableName": "fieldSetsScope"
},
v36 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "fieldSetSelectedState": "SELECTED"
    }
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "amountOfColumns"
  },
  (v35/*: any*/)
],
v37 = {
  "kind": "ScalarField",
  "name": "fieldSetId"
},
v38 = {
  "kind": "ScalarField",
  "name": "jql"
},
v39 = {
  "kind": "ScalarField",
  "name": "savedViewId"
},
v40 = {
  "args": [
    (v30/*: any*/)
  ],
  "kind": "ScalarField",
  "name": "isViewConfigModified"
},
v41 = {
  "kind": "Variable",
  "name": "groupBy",
  "variableName": "groupBy"
},
v42 = [
  (v41/*: any*/),
  (v28/*: any*/),
  (v30/*: any*/),
  {
    "kind": "Variable",
    "name": "staticViewInput",
    "variableName": "staticViewInput"
  }
],
v43 = {
  "kind": "ScalarField",
  "name": "fieldId"
},
v44 = {
  "concreteType": "JiraSpreadsheetGroupByConfig",
  "kind": "LinkedField",
  "name": "groupByConfig",
  "plural": false,
  "selections": [
    {
      "concreteType": "JiraField",
      "kind": "LinkedField",
      "name": "groupByField",
      "plural": false,
      "selections": [
        (v43/*: any*/),
        (v34/*: any*/)
      ]
    }
  ]
},
v45 = {
  "kind": "ScalarField",
  "name": "hideDone"
},
v46 = {
  "kind": "ScalarField",
  "name": "isHierarchyEnabled"
},
v47 = {
  "kind": "ScalarField",
  "name": "__id"
},
v48 = {
  "kind": "ClientExtension",
  "selections": [
    (v47/*: any*/)
  ]
},
v49 = {
  "kind": "ScalarField",
  "name": "isGroupingEnabled"
},
v50 = {
  "kind": "ScalarField",
  "name": "canEnableGrouping"
},
v51 = {
  "kind": "ScalarField",
  "name": "totalCount"
},
v52 = {
  "kind": "ScalarField",
  "name": "type"
},
v53 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v54 = {
  "kind": "ScalarField",
  "name": "jqlTerm"
},
v55 = {
  "kind": "ScalarField",
  "name": "canEnableHierarchy"
},
v56 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  }
],
v57 = {
  "kind": "ScalarField",
  "name": "value"
},
v58 = {
  "kind": "InlineFragment",
  "selections": [
    (v43/*: any*/),
    {
      "alias": "singleValueOperator",
      "kind": "ScalarField",
      "name": "operator"
    },
    (v57/*: any*/)
  ],
  "type": "JiraFormattingSingleValueOperand"
},
v59 = {
  "kind": "InlineFragment",
  "selections": [
    (v43/*: any*/),
    {
      "alias": "multipleValueOperator",
      "kind": "ScalarField",
      "name": "operator"
    },
    {
      "kind": "ScalarField",
      "name": "values"
    }
  ],
  "type": "JiraFormattingMultipleValueOperand"
},
v60 = {
  "kind": "InlineFragment",
  "selections": [
    (v43/*: any*/),
    {
      "alias": "noValueOperator",
      "kind": "ScalarField",
      "name": "operator"
    }
  ],
  "type": "JiraFormattingNoValueOperand"
},
v61 = {
  "kind": "ScalarField",
  "name": "formattingArea"
},
v62 = {
  "kind": "ScalarField",
  "name": "colorKey"
},
v63 = {
  "kind": "ScalarField",
  "name": "name"
},
v64 = [
  (v62/*: any*/),
  (v34/*: any*/)
],
v65 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "after"
},
v66 = {
  "kind": "Variable",
  "name": "before",
  "variableName": "before"
},
v67 = {
  "kind": "Variable",
  "name": "fieldSetsInput",
  "variableName": "fieldSetsInput"
},
v68 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v69 = {
  "kind": "Variable",
  "name": "last",
  "variableName": "last"
},
v70 = {
  "kind": "Variable",
  "name": "options",
  "variableName": "options"
},
v71 = {
  "kind": "Variable",
  "name": "saveJQLToUserHistory",
  "variableName": "saveJQLToUserHistory"
},
v72 = [
  (v65/*: any*/),
  (v66/*: any*/),
  (v67/*: any*/),
  (v68/*: any*/),
  (v28/*: any*/),
  (v69/*: any*/),
  (v70/*: any*/),
  (v71/*: any*/),
  (v29/*: any*/),
  (v30/*: any*/)
],
v73 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v74 = {
  "kind": "ScalarField",
  "name": "key"
},
v75 = {
  "kind": "ScalarField",
  "name": "issueId"
},
v76 = {
  "concreteType": "JiraIssueTypeHierarchyLevel",
  "kind": "LinkedField",
  "name": "hierarchy",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "level"
    }
  ]
},
v77 = {
  "concreteType": "JiraIssueTypeField",
  "kind": "LinkedField",
  "name": "issueTypeField",
  "plural": false,
  "selections": [
    {
      "concreteType": "JiraIssueType",
      "kind": "LinkedField",
      "name": "issueType",
      "plural": false,
      "selections": [
        (v76/*: any*/),
        (v34/*: any*/)
      ]
    },
    (v34/*: any*/)
  ]
},
v78 = {
  "kind": "ScalarField",
  "name": "isResolved"
},
v79 = {
  "kind": "ScalarField",
  "name": "statusCategoryId"
},
v80 = {
  "concreteType": "JiraStatusCategory",
  "kind": "LinkedField",
  "name": "statusCategory",
  "plural": false,
  "selections": [
    (v79/*: any*/),
    (v34/*: any*/)
  ]
},
v81 = {
  "concreteType": "JiraStatus",
  "kind": "LinkedField",
  "name": "status",
  "plural": false,
  "selections": [
    (v80/*: any*/),
    (v34/*: any*/)
  ]
},
v82 = {
  "concreteType": "JiraStatusField",
  "kind": "LinkedField",
  "name": "statusField",
  "plural": false,
  "selections": [
    (v81/*: any*/),
    (v34/*: any*/)
  ]
},
v83 = [
  (v63/*: any*/)
],
v84 = {
  "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "concreteType": "JiraIssueTypeField",
      "kind": "LinkedField",
      "name": "issueTypeField",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraIssueType",
          "kind": "LinkedField",
          "name": "issueType",
          "plural": false,
          "selections": (v83/*: any*/)
        }
      ]
    }
  ]
},
v85 = {
  "kind": "ClientExtension",
  "selections": [
    (v47/*: any*/),
    {
      "kind": "ScalarField",
      "name": "isHighlightedIssueRow"
    }
  ]
},
v86 = {
  "kind": "ScalarField",
  "name": "summary"
},
v87 = {
  "concreteType": "JiraAvatar",
  "kind": "LinkedField",
  "name": "avatar",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "small"
    }
  ]
},
v88 = {
  "concreteType": "JiraIssue",
  "kind": "LinkedField",
  "name": "node",
  "plural": false,
  "selections": [
    (v31/*: any*/),
    (v34/*: any*/),
    (v74/*: any*/),
    (v75/*: any*/),
    (v77/*: any*/),
    (v78/*: any*/),
    (v82/*: any*/),
    (v84/*: any*/),
    (v85/*: any*/),
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        (v86/*: any*/),
        {
          "concreteType": "JiraIssueTypeField",
          "kind": "LinkedField",
          "name": "issueTypeField",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraIssueType",
              "kind": "LinkedField",
              "name": "issueType",
              "plural": false,
              "selections": [
                (v87/*: any*/),
                {
                  "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": (v83/*: any*/)
                }
              ]
            }
          ]
        }
      ]
    }
  ]
},
v89 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 500
  }
],
v90 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isJiraIssueField"
},
v91 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraAffectedServiceConnection",
      "kind": "LinkedField",
      "name": "selectedAffectedServicesConnection",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraAffectedServiceEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraAffectedService",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "serviceId"
                },
                (v63/*: any*/),
                (v34/*: any*/)
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraAffectedServicesField"
},
v92 = [
  (v57/*: any*/),
  (v34/*: any*/),
  {
    "kind": "ScalarField",
    "name": "isDisabled"
  }
],
v93 = {
  "kind": "ScalarField",
  "name": "lazyIsEditableInIssueView"
},
v94 = {
  "kind": "ClientExtension",
  "selections": [
    (v93/*: any*/)
  ]
},
v95 = {
  "kind": "InlineFragment",
  "selections": [
    (v63/*: any*/),
    {
      "concreteType": "JiraCascadingOption",
      "kind": "LinkedField",
      "name": "cascadingOption",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraOption",
          "kind": "LinkedField",
          "name": "parentOptionValue",
          "plural": false,
          "selections": (v92/*: any*/)
        },
        {
          "concreteType": "JiraOption",
          "kind": "LinkedField",
          "name": "childOptionValue",
          "plural": false,
          "selections": (v92/*: any*/)
        }
      ]
    },
    (v94/*: any*/)
  ],
  "type": "JiraCascadingSelectField"
},
v96 = [
  (v32/*: any*/)
],
v97 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraCmdbObjectConnection",
      "kind": "LinkedField",
      "name": "selectedCmdbObjectsConnection",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraCmdbObjectEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraCmdbObject",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "objectId"
                },
                {
                  "kind": "ScalarField",
                  "name": "label"
                },
                {
                  "concreteType": "JiraCmdbAvatar",
                  "kind": "LinkedField",
                  "name": "avatar",
                  "plural": false,
                  "selections": [
                    {
                      "concreteType": "JiraCmdbMediaClientConfig",
                      "kind": "LinkedField",
                      "name": "mediaClientConfig",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "name": "clientId"
                        },
                        {
                          "kind": "ScalarField",
                          "name": "fileId"
                        },
                        {
                          "kind": "ScalarField",
                          "name": "mediaBaseUrl"
                        },
                        {
                          "kind": "ScalarField",
                          "name": "mediaJwtToken"
                        }
                      ]
                    },
                    {
                      "kind": "ScalarField",
                      "name": "url48"
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          "concreteType": "QueryError",
          "kind": "LinkedField",
          "name": "errors",
          "plural": true,
          "selections": (v96/*: any*/)
        }
      ]
    }
  ],
  "type": "JiraCMDBField"
},
v98 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  }
],
v99 = {
  "alias": "value",
  "kind": "ScalarField",
  "name": "id"
},
v100 = {
  "alias": "label",
  "kind": "ScalarField",
  "name": "name"
},
v101 = {
  "kind": "InlineFragment",
  "selections": [
    (v63/*: any*/),
    {
      "args": (v98/*: any*/),
      "concreteType": "JiraComponentConnection",
      "kind": "LinkedField",
      "name": "selectedComponentsConnection",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraComponentEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraComponent",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v99/*: any*/),
                (v100/*: any*/),
                (v34/*: any*/)
              ]
            }
          ]
        }
      ],
      "storageKey": "selectedComponentsConnection(first:1000)"
    },
    (v94/*: any*/)
  ],
  "type": "JiraComponentsField"
},
v102 = {
  "kind": "ScalarField",
  "name": "date"
},
v103 = {
  "concreteType": "JiraFieldConfig",
  "kind": "LinkedField",
  "name": "fieldConfig",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isRequired"
    }
  ]
},
v104 = {
  "kind": "InlineFragment",
  "selections": [
    (v102/*: any*/),
    (v63/*: any*/),
    (v103/*: any*/),
    (v94/*: any*/)
  ],
  "type": "JiraDatePickerField"
},
v105 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "dateTime"
    },
    (v63/*: any*/),
    (v94/*: any*/)
  ],
  "type": "JiraDateTimePickerField"
},
v106 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraEpic",
      "kind": "LinkedField",
      "name": "epic",
      "plural": false,
      "selections": [
        (v74/*: any*/),
        (v86/*: any*/),
        {
          "kind": "ScalarField",
          "name": "color"
        },
        (v34/*: any*/)
      ]
    }
  ],
  "type": "JiraEpicLinkField"
},
v107 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "renderedFieldHtml"
    }
  ],
  "type": "JiraFallbackField"
},
v108 = {
  "kind": "ScalarField",
  "name": "text"
},
v109 = {
  "kind": "InlineFragment",
  "selections": [
    (v108/*: any*/),
    (v63/*: any*/),
    (v94/*: any*/)
  ],
  "type": "JiraSingleLineTextField"
},
v110 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraStatusCategory",
      "kind": "LinkedField",
      "name": "statusCategory",
      "plural": false,
      "selections": [
        (v63/*: any*/),
        (v79/*: any*/),
        (v34/*: any*/)
      ]
    }
  ],
  "type": "JiraStatusCategoryField"
},
v111 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraStatus",
      "kind": "LinkedField",
      "name": "status",
      "plural": false,
      "selections": [
        (v63/*: any*/),
        {
          "kind": "ScalarField",
          "name": "statusId"
        },
        (v80/*: any*/),
        (v34/*: any*/)
      ]
    }
  ],
  "type": "JiraStatusField"
},
v112 = {
  "concreteType": "JiraColor",
  "kind": "LinkedField",
  "name": "color",
  "plural": false,
  "selections": (v64/*: any*/)
},
v113 = [
  (v63/*: any*/),
  (v112/*: any*/)
],
v114 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "args": (v98/*: any*/),
      "concreteType": "JiraLabelConnection",
      "kind": "LinkedField",
      "name": "selectedLabelsConnection",
      "plural": false,
      "selections": [
        (v51/*: any*/),
        {
          "concreteType": "JiraLabelEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraLabel",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": (v113/*: any*/)
            }
          ]
        }
      ],
      "storageKey": "selectedLabelsConnection(first:1000)"
    },
    (v63/*: any*/),
    (v94/*: any*/)
  ],
  "type": "JiraLabelsField"
},
v115 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraIssueType",
      "kind": "LinkedField",
      "name": "issueType",
      "plural": false,
      "selections": [
        (v87/*: any*/),
        (v63/*: any*/),
        (v34/*: any*/)
      ]
    }
  ],
  "type": "JiraIssueTypeField"
},
v116 = {
  "concreteType": "JiraAvatar",
  "kind": "LinkedField",
  "name": "avatar",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "xsmall"
    }
  ]
},
v117 = {
  "kind": "ScalarField",
  "name": "webUrl"
},
v118 = {
  "kind": "ScalarField",
  "name": "issueTypeId"
},
v119 = {
  "concreteType": "JiraStatusCategory",
  "kind": "LinkedField",
  "name": "statusCategory",
  "plural": false,
  "selections": [
    (v34/*: any*/),
    (v79/*: any*/)
  ]
},
v120 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraIssue",
      "kind": "LinkedField",
      "name": "parentIssue",
      "plural": false,
      "selections": [
        (v74/*: any*/),
        {
          "concreteType": "JiraColorField",
          "kind": "LinkedField",
          "name": "issueColorField",
          "plural": false,
          "selections": [
            (v112/*: any*/),
            (v34/*: any*/)
          ]
        },
        {
          "concreteType": "JiraIssueTypeField",
          "kind": "LinkedField",
          "name": "issueTypeField",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraIssueType",
              "kind": "LinkedField",
              "name": "issueType",
              "plural": false,
              "selections": [
                (v116/*: any*/),
                (v63/*: any*/),
                (v34/*: any*/)
              ]
            },
            (v34/*: any*/)
          ]
        },
        {
          "concreteType": "JiraSingleLineTextField",
          "kind": "LinkedField",
          "name": "summaryField",
          "plural": false,
          "selections": [
            (v108/*: any*/),
            (v34/*: any*/)
          ]
        },
        (v34/*: any*/),
        (v75/*: any*/),
        (v117/*: any*/),
        {
          "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
          "kind": "Condition",
          "passingValue": false,
          "selections": [
            {
              "args": [
                {
                  "kind": "Literal",
                  "name": "ids",
                  "value": [
                    "issuetype",
                    "project",
                    "summary",
                    "status"
                  ]
                }
              ],
              "concreteType": "JiraIssueFieldConnection",
              "kind": "LinkedField",
              "name": "fieldsById",
              "plural": false,
              "selections": [
                {
                  "concreteType": "JiraIssueFieldEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        (v31/*: any*/),
                        (v34/*: any*/),
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            (v43/*: any*/),
                            (v108/*: any*/)
                          ],
                          "type": "JiraSingleLineTextField"
                        },
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            (v43/*: any*/),
                            {
                              "concreteType": "JiraIssueType",
                              "kind": "LinkedField",
                              "name": "issueType",
                              "plural": false,
                              "selections": [
                                (v34/*: any*/),
                                (v118/*: any*/),
                                (v63/*: any*/),
                                (v116/*: any*/),
                                (v76/*: any*/)
                              ]
                            }
                          ],
                          "type": "JiraIssueTypeField"
                        },
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            (v43/*: any*/),
                            {
                              "concreteType": "JiraStatus",
                              "kind": "LinkedField",
                              "name": "status",
                              "plural": false,
                              "selections": [
                                (v34/*: any*/),
                                (v119/*: any*/)
                              ]
                            }
                          ],
                          "type": "JiraStatusField"
                        }
                      ]
                    }
                  ]
                }
              ],
              "storageKey": "fieldsById(ids:[\"issuetype\",\"project\",\"summary\",\"status\"])"
            }
          ]
        },
        {
          "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "concreteType": "JiraIssueTypeField",
              "kind": "LinkedField",
              "name": "issueTypeField",
              "plural": false,
              "selections": [
                (v43/*: any*/),
                {
                  "concreteType": "JiraIssueType",
                  "kind": "LinkedField",
                  "name": "issueType",
                  "plural": false,
                  "selections": [
                    (v118/*: any*/),
                    (v76/*: any*/)
                  ]
                }
              ]
            },
            {
              "concreteType": "JiraSingleLineTextField",
              "kind": "LinkedField",
              "name": "summaryField",
              "plural": false,
              "selections": [
                (v43/*: any*/)
              ]
            },
            {
              "concreteType": "JiraStatusField",
              "kind": "LinkedField",
              "name": "statusField",
              "plural": false,
              "selections": [
                (v34/*: any*/),
                (v43/*: any*/),
                (v81/*: any*/)
              ]
            }
          ]
        }
      ]
    },
    (v63/*: any*/),
    (v94/*: any*/)
  ],
  "type": "JiraParentIssueField"
},
v121 = {
  "kind": "ScalarField",
  "name": "iconUrl"
},
v122 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraPriority",
      "kind": "LinkedField",
      "name": "priority",
      "plural": false,
      "selections": [
        (v63/*: any*/),
        (v121/*: any*/),
        (v34/*: any*/)
      ]
    },
    (v63/*: any*/),
    (v94/*: any*/)
  ],
  "type": "JiraPriorityField"
},
v123 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraProject",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        (v63/*: any*/),
        (v74/*: any*/),
        {
          "concreteType": "JiraAvatar",
          "kind": "LinkedField",
          "name": "avatar",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "large"
            }
          ]
        },
        (v34/*: any*/)
      ]
    }
  ],
  "type": "JiraProjectField"
},
v124 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraResolution",
      "kind": "LinkedField",
      "name": "resolution",
      "plural": false,
      "selections": [
        (v63/*: any*/),
        (v34/*: any*/)
      ]
    }
  ],
  "type": "JiraResolutionField"
},
v125 = [
  (v34/*: any*/),
  {
    "kind": "ScalarField",
    "name": "sprintId"
  },
  (v63/*: any*/),
  {
    "kind": "ScalarField",
    "name": "state"
  },
  {
    "kind": "ScalarField",
    "name": "endDate"
  }
],
v126 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraSprintConnection",
      "kind": "LinkedField",
      "name": "selectedSprintsConnection",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraSprintEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraSprint",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": (v125/*: any*/)
            }
          ]
        }
      ]
    },
    (v63/*: any*/),
    (v94/*: any*/)
  ],
  "type": "JiraSprintField"
},
v127 = {
  "kind": "ScalarField",
  "name": "picture"
},
v128 = {
  "kind": "ScalarField",
  "name": "accountStatus"
},
v129 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v130 = [
  {
    "kind": "ScalarField",
    "name": "appType"
  }
],
v131 = [
  {
    "kind": "TypeDiscriminator",
    "abstractKey": "__isUser"
  },
  {
    "kind": "InlineFragment",
    "selections": (v130/*: any*/),
    "type": "AppUser"
  }
],
v132 = {
  "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider",
  "kind": "Condition",
  "passingValue": true,
  "selections": (v131/*: any*/)
},
v133 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaifetchapptypeforuserassigneerelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": (v130/*: any*/)
    }
  ],
  "type": "AppUser"
},
v134 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraRichText",
      "kind": "LinkedField",
      "name": "richText",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraADF",
          "kind": "LinkedField",
          "name": "adfValue",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraAdfToConvertedPlainText",
              "kind": "LinkedField",
              "name": "convertedPlainText",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "plainText"
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraRichTextField"
},
v135 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraServiceManagementRequestType",
      "kind": "LinkedField",
      "name": "requestType",
      "plural": false,
      "selections": [
        (v63/*: any*/),
        (v116/*: any*/),
        (v34/*: any*/)
      ]
    }
  ],
  "type": "JiraServiceManagementRequestTypeField"
},
v136 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 1
        }
      ],
      "concreteType": "JiraIssueLinkConnection",
      "kind": "LinkedField",
      "name": "issueLinkConnection",
      "plural": false,
      "selections": [
        (v51/*: any*/),
        {
          "concreteType": "JiraIssueLinkEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraIssueLink",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "concreteType": "JiraIssue",
                  "kind": "LinkedField",
                  "name": "issue",
                  "plural": false,
                  "selections": [
                    (v117/*: any*/),
                    (v74/*: any*/),
                    {
                      "args": [
                        {
                          "kind": "Literal",
                          "name": "ids",
                          "value": [
                            "statusCategory"
                          ]
                        }
                      ],
                      "concreteType": "JiraIssueFieldConnection",
                      "kind": "LinkedField",
                      "name": "fieldsById",
                      "plural": false,
                      "selections": [
                        {
                          "concreteType": "JiraIssueFieldEdge",
                          "kind": "LinkedField",
                          "name": "edges",
                          "plural": true,
                          "selections": [
                            {
                              "kind": "LinkedField",
                              "name": "node",
                              "plural": false,
                              "selections": [
                                (v31/*: any*/),
                                {
                                  "kind": "InlineFragment",
                                  "selections": [
                                    (v80/*: any*/)
                                  ],
                                  "type": "JiraStatusCategoryField"
                                },
                                (v34/*: any*/)
                              ]
                            }
                          ]
                        }
                      ],
                      "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                    },
                    {
                      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider",
                      "kind": "Condition",
                      "passingValue": true,
                      "selections": [
                        (v78/*: any*/)
                      ]
                    },
                    (v34/*: any*/)
                  ]
                },
                {
                  "kind": "ScalarField",
                  "name": "relationName"
                },
                (v34/*: any*/)
              ]
            }
          ]
        }
      ],
      "storageKey": "issueLinkConnection(first:1)"
    }
  ],
  "type": "JiraIssueLinkField"
},
v137 = {
  "kind": "ScalarField",
  "name": "number"
},
v138 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isStoryPointField"
    },
    (v137/*: any*/),
    (v63/*: any*/),
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "concreteType": "JiraNumberFieldFormatConfig",
          "kind": "LinkedField",
          "name": "formatConfig",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "formatStyle"
            },
            {
              "kind": "ScalarField",
              "name": "formatUnit"
            }
          ]
        }
      ]
    },
    (v94/*: any*/)
  ],
  "type": "JiraNumberField"
},
v139 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraCommentSummary",
      "kind": "LinkedField",
      "name": "commentSummary",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "canAddComment"
        },
        (v51/*: any*/)
      ]
    }
  ],
  "type": "JiraCommentSummaryField"
},
v140 = {
  "kind": "InlineFragment",
  "selections": [
    (v63/*: any*/),
    {
      "kind": "ScalarField",
      "name": "uri"
    },
    (v94/*: any*/)
  ],
  "type": "JiraUrlField"
},
v141 = {
  "kind": "ScalarField",
  "name": "optionId"
},
v142 = {
  "kind": "InlineFragment",
  "selections": [
    (v63/*: any*/),
    {
      "concreteType": "JiraOption",
      "kind": "LinkedField",
      "name": "fieldOption",
      "plural": false,
      "selections": [
        (v57/*: any*/),
        (v112/*: any*/),
        (v34/*: any*/),
        (v141/*: any*/)
      ]
    },
    (v94/*: any*/)
  ],
  "type": "JiraSingleSelectField"
},
v143 = {
  "kind": "InlineFragment",
  "selections": [
    (v63/*: any*/),
    {
      "concreteType": "JiraOptionConnection",
      "kind": "LinkedField",
      "name": "selectedOptions",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraOptionEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraOption",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v34/*: any*/),
                (v57/*: any*/),
                (v141/*: any*/)
              ]
            }
          ]
        }
      ]
    },
    (v94/*: any*/)
  ],
  "type": "JiraMultipleSelectField"
},
v144 = {
  "concreteType": "JiraOption",
  "kind": "LinkedField",
  "name": "node",
  "plural": false,
  "selections": [
    (v34/*: any*/),
    (v57/*: any*/)
  ]
},
v145 = {
  "kind": "InlineFragment",
  "selections": [
    (v63/*: any*/),
    {
      "concreteType": "JiraUserConnection",
      "kind": "LinkedField",
      "name": "selectedUsersConnection",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraUserEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v31/*: any*/),
                (v129/*: any*/),
                (v63/*: any*/),
                (v127/*: any*/),
                (v34/*: any*/),
                (v128/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "email"
                    }
                  ],
                  "type": "AtlassianAccountUser"
                }
              ]
            }
          ]
        }
      ]
    },
    (v94/*: any*/)
  ],
  "type": "JiraMultipleSelectUserPickerField"
},
v146 = {
  "kind": "InlineFragment",
  "selections": [
    (v63/*: any*/),
    {
      "concreteType": "JiraTeamView",
      "kind": "LinkedField",
      "name": "selectedTeam",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "jiraSuppliedId"
        },
        {
          "kind": "ScalarField",
          "name": "jiraSuppliedName"
        }
      ]
    },
    (v94/*: any*/)
  ],
  "type": "JiraTeamViewField"
},
v147 = {
  "concreteType": "JiraEstimate",
  "kind": "LinkedField",
  "name": "originalEstimate",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "timeInSeconds"
    }
  ]
},
v148 = {
  "concreteType": "JiraTimeTrackingSettings",
  "kind": "LinkedField",
  "name": "timeTrackingSettings",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "workingHoursPerDay"
    },
    {
      "kind": "ScalarField",
      "name": "workingDaysPerWeek"
    },
    {
      "kind": "ScalarField",
      "name": "defaultFormat"
    },
    {
      "kind": "ScalarField",
      "name": "defaultUnit"
    }
  ]
},
v149 = {
  "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider",
  "kind": "Condition",
  "passingValue": false,
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "JiraIssue",
          "kind": "LinkedField",
          "name": "issue",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraTimeTrackingField",
              "kind": "LinkedField",
              "name": "timeTrackingField",
              "plural": false,
              "selections": [
                (v34/*: any*/),
                (v147/*: any*/),
                (v148/*: any*/),
                (v43/*: any*/),
                (v63/*: any*/),
                (v52/*: any*/),
                (v94/*: any*/)
              ]
            },
            (v34/*: any*/)
          ]
        }
      ],
      "type": "JiraOriginalTimeEstimateField"
    }
  ]
},
v150 = {
  "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "JiraIssue",
          "kind": "LinkedField",
          "name": "issue",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraTimeTrackingField",
              "kind": "LinkedField",
              "name": "timeTrackingField",
              "plural": false,
              "selections": [
                (v147/*: any*/),
                (v148/*: any*/),
                (v34/*: any*/),
                (v43/*: any*/),
                (v63/*: any*/),
                (v52/*: any*/)
              ]
            },
            (v34/*: any*/)
          ]
        },
        (v94/*: any*/)
      ],
      "type": "JiraOriginalTimeEstimateField"
    }
  ]
},
v151 = {
  "kind": "InlineFragment",
  "selections": [
    (v63/*: any*/),
    {
      "concreteType": "JiraOption",
      "kind": "LinkedField",
      "name": "selectedOption",
      "plural": false,
      "selections": [
        {
          "alias": "label",
          "kind": "ScalarField",
          "name": "value"
        },
        (v34/*: any*/),
        (v99/*: any*/)
      ]
    },
    (v94/*: any*/)
  ],
  "type": "JiraRadioSelectField"
},
v152 = {
  "kind": "ScalarField",
  "name": "versionId"
},
v153 = {
  "kind": "InlineFragment",
  "selections": [
    (v63/*: any*/),
    {
      "args": (v98/*: any*/),
      "concreteType": "JiraVersionConnection",
      "kind": "LinkedField",
      "name": "selectedVersionsConnection",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraVersionEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraVersion",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v34/*: any*/),
                (v63/*: any*/),
                (v99/*: any*/),
                (v100/*: any*/),
                (v152/*: any*/)
              ]
            }
          ]
        }
      ],
      "storageKey": "selectedVersionsConnection(first:1000)"
    },
    (v94/*: any*/)
  ],
  "type": "JiraMultipleVersionPickerField"
},
v154 = [
  (v34/*: any*/)
],
v155 = {
  "concreteType": "JiraIssue",
  "kind": "LinkedField",
  "name": "issue",
  "plural": false,
  "selections": (v154/*: any*/)
},
v156 = {
  "kind": "ScalarField",
  "name": "status"
},
v157 = {
  "kind": "InlineFragment",
  "selections": [
    (v63/*: any*/),
    (v155/*: any*/),
    {
      "args": (v98/*: any*/),
      "concreteType": "JiraGoalConnection",
      "kind": "LinkedField",
      "name": "selectedGoals",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraGoalEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraGoal",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v34/*: any*/),
                (v74/*: any*/),
                {
                  "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    (v63/*: any*/),
                    (v156/*: any*/)
                  ]
                }
              ]
            }
          ]
        },
        (v48/*: any*/)
      ],
      "storageKey": "selectedGoals(first:1000)"
    },
    {
      "kind": "ClientExtension",
      "selections": [
        (v47/*: any*/),
        (v93/*: any*/)
      ]
    }
  ],
  "type": "JiraGoalsField"
},
v158 = {
  "kind": "ScalarField",
  "name": "privateProject"
},
v159 = {
  "kind": "ScalarField",
  "name": "hasPermission"
},
v160 = {
  "kind": "ScalarField",
  "name": "iconName"
},
v161 = {
  "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        (v63/*: any*/),
        (v155/*: any*/),
        {
          "kind": "ScalarField",
          "name": "isLinkEditable"
        },
        {
          "concreteType": "JiraTownsquareProject",
          "kind": "LinkedField",
          "name": "project",
          "plural": false,
          "selections": [
            (v34/*: any*/),
            {
              "alias": "atlasProjectName",
              "kind": "ScalarField",
              "name": "name"
            },
            {
              "alias": "atlasProjectKey",
              "kind": "ScalarField",
              "name": "key"
            },
            (v158/*: any*/),
            (v159/*: any*/),
            {
              "kind": "ScalarField",
              "name": "isWorkspaceActive"
            },
            (v160/*: any*/)
          ]
        },
        (v94/*: any*/)
      ],
      "type": "JiraTownsquareProjectField"
    }
  ]
},
v162 = {
  "kind": "ScalarField",
  "name": "href"
},
v163 = {
  "kind": "InlineFragment",
  "selections": [
    (v63/*: any*/),
    {
      "args": (v98/*: any*/),
      "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
      "kind": "LinkedField",
      "name": "confluenceRemoteIssueLinks",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraConfluenceRemoteIssueLink",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v34/*: any*/),
                (v162/*: any*/),
                {
                  "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "name": "pageContent",
                      "plural": false,
                      "selections": [
                        (v31/*: any*/),
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            (v162/*: any*/)
                          ],
                          "type": "JiraConfluencePageContentDetails"
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        },
        (v51/*: any*/)
      ],
      "storageKey": "confluenceRemoteIssueLinks(first:1000)"
    },
    (v94/*: any*/)
  ],
  "type": "JiraConfluenceRemoteIssueLinksField"
},
v164 = {
  "kind": "ScalarField",
  "name": "groupId"
},
v165 = {
  "kind": "InlineFragment",
  "selections": [
    (v63/*: any*/),
    {
      "concreteType": "JiraGroupConnection",
      "kind": "LinkedField",
      "name": "selectedGroupsConnection",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraGroupEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraGroup",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v34/*: any*/),
                (v63/*: any*/),
                (v164/*: any*/)
              ]
            }
          ]
        }
      ]
    },
    (v94/*: any*/)
  ],
  "type": "JiraMultipleGroupPickerField"
},
v166 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraFlag",
      "kind": "LinkedField",
      "name": "flag",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isFlagged"
        }
      ]
    }
  ],
  "type": "JiraFlagField"
},
v167 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraWatch",
      "kind": "LinkedField",
      "name": "watch",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "count"
        },
        {
          "kind": "ScalarField",
          "name": "isWatching"
        }
      ]
    }
  ],
  "type": "JiraWatchesField"
},
v168 = [
  {
    "kind": "Literal",
    "name": "viewId",
    "value": "list_default"
  }
],
v169 = {
  "kind": "InlineFragment",
  "selections": [
    (v102/*: any*/)
  ],
  "type": "JiraDatePickerField"
},
v170 = [
  (v31/*: any*/),
  (v43/*: any*/),
  (v169/*: any*/),
  (v34/*: any*/)
],
v171 = [
  (v31/*: any*/),
  (v169/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": (v154/*: any*/),
    "type": "Node",
    "abstractKey": "__isNode"
  }
],
v172 = {
  "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "concreteType": "JiraIssue",
              "kind": "LinkedField",
              "name": "issue",
              "plural": false,
              "selections": [
                (v34/*: any*/),
                (v75/*: any*/),
                {
                  "concreteType": "JiraIssueTypeField",
                  "kind": "LinkedField",
                  "name": "issueTypeField",
                  "plural": false,
                  "selections": [
                    {
                      "concreteType": "JiraIssueType",
                      "kind": "LinkedField",
                      "name": "issueType",
                      "plural": false,
                      "selections": [
                        (v63/*: any*/),
                        (v76/*: any*/),
                        (v34/*: any*/)
                      ]
                    },
                    (v34/*: any*/)
                  ]
                },
                {
                  "concreteType": "JiraParentIssueField",
                  "kind": "LinkedField",
                  "name": "parentIssueField",
                  "plural": false,
                  "selections": [
                    {
                      "concreteType": "JiraIssue",
                      "kind": "LinkedField",
                      "name": "parentIssue",
                      "plural": false,
                      "selections": [
                        (v75/*: any*/),
                        (v74/*: any*/),
                        (v34/*: any*/)
                      ]
                    },
                    (v34/*: any*/)
                  ]
                },
                (v74/*: any*/),
                (v82/*: any*/),
                {
                  "concreteType": "JiraSingleSelectUserPickerField",
                  "kind": "LinkedField",
                  "name": "assigneeField",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "name": "user",
                      "plural": false,
                      "selections": [
                        (v31/*: any*/),
                        (v127/*: any*/),
                        (v34/*: any*/)
                      ]
                    },
                    (v34/*: any*/)
                  ]
                },
                {
                  "args": (v168/*: any*/),
                  "kind": "LinkedField",
                  "name": "startDateViewField",
                  "plural": false,
                  "selections": (v170/*: any*/),
                  "storageKey": "startDateViewField(viewId:\"list_default\")"
                },
                {
                  "args": (v168/*: any*/),
                  "kind": "LinkedField",
                  "name": "endDateViewField",
                  "plural": false,
                  "selections": (v170/*: any*/),
                  "storageKey": "endDateViewField(viewId:\"list_default\")"
                }
              ]
            },
            {
              "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "name": "aggregatedStartDateViewField",
                      "plural": false,
                      "selections": (v171/*: any*/)
                    },
                    {
                      "kind": "LinkedField",
                      "name": "aggregatedEndDateViewField",
                      "plural": false,
                      "selections": (v171/*: any*/)
                    }
                  ],
                  "type": "JiraAggregatedTimelineField"
                }
              ]
            }
          ],
          "type": "JiraTimelineVirtualField",
          "abstractKey": "__isJiraTimelineVirtualField"
        }
      ],
      "type": "JiraAggregatedTimelineField"
    }
  ]
},
v173 = {
  "kind": "ScalarField",
  "name": "priorityId"
},
v174 = [
  (v31/*: any*/),
  (v34/*: any*/)
],
v175 = {
  "args": (v89/*: any*/),
  "concreteType": "JiraIssueFieldSetConnection",
  "kind": "LinkedField",
  "name": "fieldSets",
  "plural": false,
  "selections": [
    {
      "concreteType": "JiraIssueFieldSetEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "JiraIssueFieldSet",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v52/*: any*/),
            (v37/*: any*/),
            {
              "concreteType": "JiraIssueFieldConnection",
              "kind": "LinkedField",
              "name": "fields",
              "plural": false,
              "selections": [
                (v51/*: any*/),
                {
                  "concreteType": "JiraIssueFieldEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        (v34/*: any*/),
                        (v31/*: any*/),
                        (v43/*: any*/),
                        (v52/*: any*/),
                        (v90/*: any*/),
                        (v91/*: any*/),
                        (v95/*: any*/),
                        (v97/*: any*/),
                        (v101/*: any*/),
                        (v104/*: any*/),
                        (v105/*: any*/),
                        (v106/*: any*/),
                        (v107/*: any*/),
                        (v109/*: any*/),
                        (v110/*: any*/),
                        (v111/*: any*/),
                        (v114/*: any*/),
                        (v115/*: any*/),
                        (v120/*: any*/),
                        (v122/*: any*/),
                        (v123/*: any*/),
                        (v124/*: any*/),
                        (v126/*: any*/),
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            (v63/*: any*/),
                            {
                              "kind": "LinkedField",
                              "name": "user",
                              "plural": false,
                              "selections": [
                                (v31/*: any*/),
                                (v63/*: any*/),
                                (v127/*: any*/),
                                (v128/*: any*/),
                                (v34/*: any*/),
                                (v129/*: any*/),
                                (v132/*: any*/),
                                (v133/*: any*/),
                                {
                                  "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerninrelayprovider",
                                  "kind": "Condition",
                                  "passingValue": true,
                                  "selections": (v131/*: any*/)
                                }
                              ]
                            },
                            (v103/*: any*/),
                            (v94/*: any*/)
                          ],
                          "type": "JiraSingleSelectUserPickerField"
                        },
                        (v134/*: any*/),
                        (v135/*: any*/),
                        (v136/*: any*/),
                        (v138/*: any*/),
                        (v139/*: any*/),
                        (v140/*: any*/),
                        (v142/*: any*/),
                        (v143/*: any*/),
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            (v63/*: any*/),
                            {
                              "concreteType": "JiraOptionConnection",
                              "kind": "LinkedField",
                              "name": "selectedOptions",
                              "plural": false,
                              "selections": [
                                {
                                  "concreteType": "JiraOptionEdge",
                                  "kind": "LinkedField",
                                  "name": "edges",
                                  "plural": true,
                                  "selections": [
                                    (v144/*: any*/),
                                    (v48/*: any*/)
                                  ]
                                }
                              ]
                            },
                            (v94/*: any*/)
                          ],
                          "type": "JiraCheckboxesField"
                        },
                        (v145/*: any*/),
                        (v146/*: any*/),
                        (v149/*: any*/),
                        (v150/*: any*/),
                        (v151/*: any*/),
                        (v153/*: any*/),
                        (v157/*: any*/),
                        (v161/*: any*/),
                        (v163/*: any*/),
                        (v165/*: any*/),
                        (v166/*: any*/),
                        (v167/*: any*/),
                        (v172/*: any*/),
                        (v48/*: any*/)
                      ]
                    }
                  ]
                }
              ]
            },
            (v48/*: any*/)
          ]
        }
      ]
    },
    {
      "condition": "isConditionalFormattingEnabled",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "concreteType": "JiraIssueFieldSetEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraIssueFieldSet",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "concreteType": "JiraIssueFieldConnection",
                  "kind": "LinkedField",
                  "name": "fields",
                  "plural": false,
                  "selections": [
                    {
                      "concreteType": "JiraIssueFieldEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "args": (v98/*: any*/),
                                  "concreteType": "JiraComponentConnection",
                                  "kind": "LinkedField",
                                  "name": "selectedComponentsConnection",
                                  "plural": false,
                                  "selections": [
                                    {
                                      "concreteType": "JiraComponentEdge",
                                      "kind": "LinkedField",
                                      "name": "edges",
                                      "plural": true,
                                      "selections": [
                                        {
                                          "concreteType": "JiraComponent",
                                          "kind": "LinkedField",
                                          "name": "node",
                                          "plural": false,
                                          "selections": [
                                            {
                                              "kind": "ScalarField",
                                              "name": "componentId"
                                            }
                                          ]
                                        }
                                      ]
                                    }
                                  ],
                                  "storageKey": "selectedComponentsConnection(first:1000)"
                                }
                              ],
                              "type": "JiraComponentsField"
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "concreteType": "JiraPriority",
                                  "kind": "LinkedField",
                                  "name": "priority",
                                  "plural": false,
                                  "selections": [
                                    (v173/*: any*/)
                                  ]
                                }
                              ],
                              "type": "JiraPriorityField"
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "concreteType": "JiraProject",
                                  "kind": "LinkedField",
                                  "name": "project",
                                  "plural": false,
                                  "selections": [
                                    {
                                      "kind": "ScalarField",
                                      "name": "projectId"
                                    }
                                  ]
                                }
                              ],
                              "type": "JiraProjectField"
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "concreteType": "JiraVersion",
                                  "kind": "LinkedField",
                                  "name": "version",
                                  "plural": false,
                                  "selections": [
                                    (v152/*: any*/),
                                    (v34/*: any*/)
                                  ]
                                }
                              ],
                              "type": "JiraSingleVersionPickerField"
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "concreteType": "JiraIssueType",
                                  "kind": "LinkedField",
                                  "name": "issueType",
                                  "plural": false,
                                  "selections": [
                                    (v118/*: any*/)
                                  ]
                                }
                              ],
                              "type": "JiraIssueTypeField"
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "kind": "LinkedField",
                                  "name": "selectedValue",
                                  "plural": false,
                                  "selections": (v174/*: any*/)
                                }
                              ],
                              "type": "JiraSingleSelectField"
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "concreteType": "JiraSelectableValueConnection",
                                  "kind": "LinkedField",
                                  "name": "selectedValues",
                                  "plural": false,
                                  "selections": [
                                    {
                                      "concreteType": "JiraSelectableValueEdge",
                                      "kind": "LinkedField",
                                      "name": "edges",
                                      "plural": true,
                                      "selections": [
                                        {
                                          "kind": "LinkedField",
                                          "name": "node",
                                          "plural": false,
                                          "selections": (v174/*: any*/)
                                        }
                                      ]
                                    }
                                  ]
                                }
                              ],
                              "type": "JiraMultipleSelectField"
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "storageKey": "fieldSets(first:500)"
},
v176 = {
  "kind": "ScalarField",
  "name": "endCursor"
},
v177 = {
  "kind": "ScalarField",
  "name": "hasNextPage"
},
v178 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    (v176/*: any*/),
    {
      "kind": "ScalarField",
      "name": "startCursor"
    },
    (v177/*: any*/),
    {
      "kind": "ScalarField",
      "name": "hasPreviousPage"
    }
  ]
},
v179 = {
  "concreteType": "JiraIssueNavigatorPageInfo",
  "kind": "LinkedField",
  "name": "issueNavigatorPageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "firstIssuePosition"
    },
    {
      "kind": "ScalarField",
      "name": "lastIssuePosition"
    }
  ]
},
v180 = {
  "kind": "ScalarField",
  "name": "pageNumber"
},
v181 = {
  "kind": "ScalarField",
  "name": "isCurrent"
},
v182 = [
  (v180/*: any*/),
  (v73/*: any*/),
  (v181/*: any*/)
],
v183 = {
  "args": [
    {
      "kind": "Literal",
      "name": "maxCursors",
      "value": 7
    }
  ],
  "concreteType": "JiraPageCursors",
  "kind": "LinkedField",
  "name": "pageCursors",
  "plural": false,
  "selections": [
    {
      "concreteType": "JiraPageCursor",
      "kind": "LinkedField",
      "name": "around",
      "plural": true,
      "selections": (v182/*: any*/)
    },
    {
      "concreteType": "JiraPageCursor",
      "kind": "LinkedField",
      "name": "last",
      "plural": false,
      "selections": (v182/*: any*/)
    },
    {
      "concreteType": "JiraPageCursor",
      "kind": "LinkedField",
      "name": "first",
      "plural": false,
      "selections": [
        (v73/*: any*/),
        (v180/*: any*/),
        (v181/*: any*/)
      ]
    }
  ],
  "storageKey": "pageCursors(maxCursors:7)"
},
v184 = {
  "kind": "ScalarField",
  "name": "totalIssueSearchResultCount"
},
v185 = {
  "kind": "LinkedField",
  "name": "issueSearchError",
  "plural": false,
  "selections": [
    (v31/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "messages"
        }
      ],
      "type": "JiraInvalidJqlError"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v32/*: any*/),
        {
          "kind": "ScalarField",
          "name": "errorType"
        }
      ],
      "type": "JiraInvalidSyntaxError"
    },
    {
      "kind": "InlineFragment",
      "selections": (v96/*: any*/),
      "type": "JiraServerError"
    }
  ]
},
v186 = {
  "kind": "ScalarField",
  "name": "isCappingIssueSearchResult"
},
v187 = {
  "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcfrontierformulafieldd1relayprovider",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "concreteType": "JiraIssueEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "JiraIssue",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v86/*: any*/)
          ]
        }
      ]
    }
  ]
},
v188 = {
  "args": (v72/*: any*/),
  "concreteType": "JiraIssueConnection",
  "kind": "LinkedField",
  "name": "issues",
  "plural": false,
  "selections": [
    {
      "concreteType": "JiraIssueEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        (v73/*: any*/),
        (v88/*: any*/),
        (v31/*: any*/),
        (v175/*: any*/),
        (v48/*: any*/)
      ]
    },
    (v178/*: any*/),
    (v179/*: any*/),
    (v183/*: any*/),
    (v184/*: any*/),
    (v185/*: any*/),
    (v38/*: any*/),
    (v186/*: any*/),
    (v48/*: any*/),
    (v187/*: any*/)
  ]
},
v189 = [
  "scope"
],
v190 = [
  "issueSearchInput"
],
v191 = [
  (v65/*: any*/),
  (v66/*: any*/),
  (v68/*: any*/),
  (v41/*: any*/),
  (v28/*: any*/),
  (v69/*: any*/),
  (v71/*: any*/),
  (v29/*: any*/),
  (v30/*: any*/)
],
v192 = {
  "kind": "ScalarField",
  "name": "fieldType"
},
v193 = {
  "kind": "LinkedField",
  "name": "fieldValue",
  "plural": false,
  "selections": [
    (v31/*: any*/),
    (v54/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "JiraPriority",
          "kind": "LinkedField",
          "name": "priority",
          "plural": false,
          "selections": [
            (v34/*: any*/),
            (v173/*: any*/),
            (v63/*: any*/),
            (v121/*: any*/)
          ]
        },
        (v53/*: any*/)
      ],
      "type": "JiraJqlPriorityFieldValue"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            (v31/*: any*/),
            (v34/*: any*/),
            (v129/*: any*/),
            (v63/*: any*/),
            (v127/*: any*/)
          ]
        },
        (v53/*: any*/)
      ],
      "type": "JiraJqlUserFieldValue"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "JiraStatus",
          "kind": "LinkedField",
          "name": "status",
          "plural": false,
          "selections": [
            (v34/*: any*/),
            (v63/*: any*/),
            (v119/*: any*/)
          ]
        },
        (v53/*: any*/),
        (v80/*: any*/)
      ],
      "type": "JiraJqlStatusFieldValue"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v137/*: any*/)
      ],
      "type": "JiraJqlNumberFieldValue"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "JiraOption",
          "kind": "LinkedField",
          "name": "option",
          "plural": false,
          "selections": [
            (v34/*: any*/),
            (v141/*: any*/),
            (v57/*: any*/),
            (v112/*: any*/)
          ]
        },
        (v53/*: any*/)
      ],
      "type": "JiraJqlOptionFieldValue"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "JiraSprint",
          "kind": "LinkedField",
          "name": "sprint",
          "plural": false,
          "selections": (v125/*: any*/)
        },
        (v53/*: any*/)
      ],
      "type": "JiraJqlSprintFieldValue"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "JiraLabel",
          "kind": "LinkedField",
          "name": "label",
          "plural": false,
          "selections": (v113/*: any*/)
        }
      ],
      "type": "JiraJqlLabelFieldValue"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "JiraGroup",
          "kind": "LinkedField",
          "name": "group",
          "plural": false,
          "selections": [
            (v34/*: any*/),
            (v164/*: any*/),
            (v63/*: any*/)
          ]
        }
      ],
      "type": "JiraJqlGroupFieldValue"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "JiraVersion",
          "kind": "LinkedField",
          "name": "version",
          "plural": false,
          "selections": [
            (v34/*: any*/),
            (v152/*: any*/),
            (v63/*: any*/)
          ]
        },
        (v53/*: any*/)
      ],
      "type": "JiraJqlVersionFieldValue"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v53/*: any*/),
        {
          "concreteType": "JiraGoal",
          "kind": "LinkedField",
          "name": "goal",
          "plural": false,
          "selections": [
            (v156/*: any*/),
            {
              "kind": "ScalarField",
              "name": "score"
            },
            (v34/*: any*/)
          ]
        }
      ],
      "type": "JiraJqlGoalsFieldValue"
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyprojectsrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "concreteType": "JiraTownsquareProject",
              "kind": "LinkedField",
              "name": "project",
              "plural": false,
              "selections": [
                (v34/*: any*/),
                (v74/*: any*/),
                (v158/*: any*/),
                (v159/*: any*/),
                (v63/*: any*/),
                (v160/*: any*/)
              ]
            }
          ],
          "type": "JiraJqlTownsquareProjectFieldValue"
        }
      ]
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "JiraIssueType",
          "kind": "LinkedField",
          "name": "issueTypes",
          "plural": true,
          "selections": [
            (v63/*: any*/),
            (v87/*: any*/),
            (v34/*: any*/),
            (v118/*: any*/),
            (v76/*: any*/)
          ]
        }
      ],
      "type": "JiraJqlIssueTypeFieldValue"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v53/*: any*/),
        {
          "concreteType": "JiraResolution",
          "kind": "LinkedField",
          "name": "resolution",
          "plural": false,
          "selections": [
            (v34/*: any*/),
            (v63/*: any*/)
          ]
        }
      ],
      "type": "JiraJqlResolutionFieldValue"
    }
  ]
},
v194 = {
  "kind": "ScalarField",
  "name": "issueCount"
},
v195 = {
  "kind": "Variable",
  "name": "viewConfigInput",
  "variableName": "viewConfigInput"
},
v196 = [
  (v67/*: any*/),
  {
    "kind": "Literal",
    "name": "first",
    "value": 50
  },
  (v35/*: any*/),
  (v30/*: any*/),
  (v195/*: any*/)
],
v197 = {
  "args": (v191/*: any*/),
  "concreteType": "JiraSpreadsheetGroupConnection",
  "kind": "LinkedField",
  "name": "groups",
  "plural": false,
  "selections": [
    {
      "concreteType": "JiraSpreadsheetGroupEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        (v73/*: any*/),
        {
          "concreteType": "JiraSpreadsheetGroup",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v31/*: any*/),
            (v34/*: any*/),
            (v38/*: any*/),
            (v43/*: any*/),
            (v192/*: any*/),
            (v37/*: any*/),
            (v193/*: any*/),
            (v194/*: any*/)
          ]
        },
        (v31/*: any*/)
      ]
    },
    (v178/*: any*/),
    {
      "kind": "ScalarField",
      "name": "groupByField"
    },
    (v38/*: any*/),
    {
      "concreteType": "QueryError",
      "kind": "LinkedField",
      "name": "errors",
      "plural": true,
      "selections": (v33/*: any*/)
    },
    {
      "condition": "isPaginating",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "concreteType": "JiraSpreadsheetGroup",
          "kind": "LinkedField",
          "name": "firstGroup",
          "plural": false,
          "selections": [
            (v34/*: any*/),
            {
              "args": (v196/*: any*/),
              "concreteType": "JiraIssueConnection",
              "kind": "LinkedField",
              "name": "issues",
              "plural": false,
              "selections": [
                {
                  "concreteType": "JiraIssueEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    (v31/*: any*/),
                    (v73/*: any*/),
                    {
                      "concreteType": "JiraIssue",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        (v31/*: any*/),
                        (v34/*: any*/),
                        (v75/*: any*/),
                        (v74/*: any*/),
                        (v77/*: any*/),
                        (v78/*: any*/),
                        (v82/*: any*/),
                        (v84/*: any*/),
                        (v85/*: any*/)
                      ]
                    },
                    {
                      "args": (v89/*: any*/),
                      "concreteType": "JiraIssueFieldSetConnection",
                      "kind": "LinkedField",
                      "name": "fieldSets",
                      "plural": false,
                      "selections": [
                        {
                          "concreteType": "JiraIssueFieldSetEdge",
                          "kind": "LinkedField",
                          "name": "edges",
                          "plural": true,
                          "selections": [
                            {
                              "concreteType": "JiraIssueFieldSet",
                              "kind": "LinkedField",
                              "name": "node",
                              "plural": false,
                              "selections": [
                                (v52/*: any*/),
                                (v37/*: any*/),
                                {
                                  "concreteType": "JiraIssueFieldConnection",
                                  "kind": "LinkedField",
                                  "name": "fields",
                                  "plural": false,
                                  "selections": [
                                    (v51/*: any*/),
                                    {
                                      "concreteType": "JiraIssueFieldEdge",
                                      "kind": "LinkedField",
                                      "name": "edges",
                                      "plural": true,
                                      "selections": [
                                        {
                                          "kind": "LinkedField",
                                          "name": "node",
                                          "plural": false,
                                          "selections": [
                                            (v34/*: any*/),
                                            (v31/*: any*/),
                                            (v43/*: any*/),
                                            (v52/*: any*/),
                                            (v90/*: any*/),
                                            (v91/*: any*/),
                                            (v95/*: any*/),
                                            (v97/*: any*/),
                                            (v101/*: any*/),
                                            (v104/*: any*/),
                                            (v105/*: any*/),
                                            (v106/*: any*/),
                                            (v107/*: any*/),
                                            (v109/*: any*/),
                                            (v110/*: any*/),
                                            (v111/*: any*/),
                                            (v114/*: any*/),
                                            (v115/*: any*/),
                                            (v120/*: any*/),
                                            (v122/*: any*/),
                                            (v123/*: any*/),
                                            (v124/*: any*/),
                                            (v126/*: any*/),
                                            {
                                              "kind": "InlineFragment",
                                              "selections": [
                                                (v63/*: any*/),
                                                {
                                                  "kind": "LinkedField",
                                                  "name": "user",
                                                  "plural": false,
                                                  "selections": [
                                                    (v31/*: any*/),
                                                    (v63/*: any*/),
                                                    (v127/*: any*/),
                                                    (v128/*: any*/),
                                                    (v34/*: any*/),
                                                    (v129/*: any*/),
                                                    (v132/*: any*/),
                                                    (v133/*: any*/)
                                                  ]
                                                },
                                                (v103/*: any*/),
                                                (v94/*: any*/)
                                              ],
                                              "type": "JiraSingleSelectUserPickerField"
                                            },
                                            (v134/*: any*/),
                                            (v135/*: any*/),
                                            (v136/*: any*/),
                                            (v138/*: any*/),
                                            (v139/*: any*/),
                                            (v140/*: any*/),
                                            (v142/*: any*/),
                                            (v143/*: any*/),
                                            {
                                              "kind": "InlineFragment",
                                              "selections": [
                                                (v63/*: any*/),
                                                {
                                                  "concreteType": "JiraOptionConnection",
                                                  "kind": "LinkedField",
                                                  "name": "selectedOptions",
                                                  "plural": false,
                                                  "selections": [
                                                    {
                                                      "concreteType": "JiraOptionEdge",
                                                      "kind": "LinkedField",
                                                      "name": "edges",
                                                      "plural": true,
                                                      "selections": [
                                                        (v144/*: any*/)
                                                      ]
                                                    }
                                                  ]
                                                },
                                                (v94/*: any*/)
                                              ],
                                              "type": "JiraCheckboxesField"
                                            },
                                            (v145/*: any*/),
                                            (v146/*: any*/),
                                            (v149/*: any*/),
                                            (v150/*: any*/),
                                            (v151/*: any*/),
                                            (v153/*: any*/),
                                            (v157/*: any*/),
                                            (v161/*: any*/),
                                            (v163/*: any*/),
                                            (v165/*: any*/),
                                            (v166/*: any*/),
                                            (v167/*: any*/),
                                            (v172/*: any*/),
                                            (v48/*: any*/)
                                          ]
                                        }
                                      ]
                                    }
                                  ]
                                }
                              ]
                            }
                          ]
                        }
                      ],
                      "storageKey": "fieldSets(first:500)"
                    },
                    (v48/*: any*/)
                  ]
                },
                {
                  "concreteType": "PageInfo",
                  "kind": "LinkedField",
                  "name": "pageInfo",
                  "plural": false,
                  "selections": [
                    (v176/*: any*/),
                    (v177/*: any*/)
                  ]
                },
                (v184/*: any*/),
                (v186/*: any*/),
                (v48/*: any*/)
              ]
            },
            {
              "args": (v196/*: any*/),
              "filters": [
                "viewConfigInput",
                "fieldSetsInput",
                "scope",
                "settings"
              ],
              "handle": "connection",
              "key": "firstGroupSection_nativeIssueTable__issues",
              "kind": "LinkedHandle",
              "name": "issues"
            },
            (v38/*: any*/),
            (v43/*: any*/),
            (v192/*: any*/),
            (v37/*: any*/),
            (v193/*: any*/),
            (v194/*: any*/)
          ]
        }
      ]
    },
    (v48/*: any*/)
  ]
},
v198 = [
  (v65/*: any*/),
  (v66/*: any*/),
  (v67/*: any*/),
  (v68/*: any*/),
  (v28/*: any*/),
  (v69/*: any*/),
  (v70/*: any*/),
  (v71/*: any*/),
  (v29/*: any*/),
  (v30/*: any*/),
  (v195/*: any*/)
],
v199 = {
  "args": (v198/*: any*/),
  "concreteType": "JiraIssueConnection",
  "kind": "LinkedField",
  "name": "issues",
  "plural": false,
  "selections": [
    {
      "concreteType": "JiraIssueEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        (v73/*: any*/),
        (v88/*: any*/),
        (v31/*: any*/),
        (v175/*: any*/),
        {
          "condition": "shouldQueryHasChildren",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "args": [
                {
                  "kind": "Variable",
                  "name": "filterByProjectKeys",
                  "variableName": "projectKeys"
                }
              ],
              "kind": "ScalarField",
              "name": "hasChildren"
            },
            {
              "args": [
                (v27/*: any*/)
              ],
              "kind": "ScalarField",
              "name": "canHaveChildIssues"
            }
          ]
        },
        (v48/*: any*/)
      ]
    },
    (v178/*: any*/),
    (v179/*: any*/),
    (v183/*: any*/),
    (v184/*: any*/),
    (v185/*: any*/),
    (v38/*: any*/),
    (v186/*: any*/),
    (v48/*: any*/),
    (v187/*: any*/)
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/),
      (v18/*: any*/),
      (v19/*: any*/),
      (v20/*: any*/),
      (v21/*: any*/),
      (v22/*: any*/),
      (v23/*: any*/),
      (v24/*: any*/),
      (v25/*: any*/),
      (v26/*: any*/)
    ],
    "kind": "Fragment",
    "name": "IssueNavigatorIssueSearchRefetchQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "isConditionalFormattingEnabled",
            "variableName": "isConditionalFormattingEnabled"
          },
          {
            "kind": "Variable",
            "name": "isSavedViewConditionalFormattingEnabled",
            "variableName": "isSavedViewConditionalFormattingEnabled"
          },
          (v27/*: any*/),
          {
            "kind": "Variable",
            "name": "projectKeys",
            "variableName": "projectKeys"
          }
        ],
        "kind": "FragmentSpread",
        "name": "main_issueNavigator_IssueNavigator_refetchQuery"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/),
      (v18/*: any*/),
      (v19/*: any*/),
      (v20/*: any*/),
      (v21/*: any*/),
      (v22/*: any*/),
      (v23/*: any*/),
      (v24/*: any*/),
      (v25/*: any*/),
      (v26/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraninlastusedjqlrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisfrozencolumnsenabledrelayprovidertsx"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcbulkopsselectallrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscissuerankingrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewconditionalformattingenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcfrontierformulafieldd1relayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcinitialisevirtualiserstatefromrelaystorerelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcmimicflatlistrsswhileuninitialisedrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreducererendersrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaifetchapptypeforuserassigneerelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerninrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyprojectsrelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "IssueNavigatorIssueSearchRefetchQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
              },
              {
                "kind": "Variable",
                "name": "filterId",
                "variableName": "filterId"
              },
              (v28/*: any*/),
              {
                "kind": "Variable",
                "name": "namespace",
                "variableName": "namespace"
              },
              (v29/*: any*/),
              (v30/*: any*/),
              {
                "kind": "Variable",
                "name": "viewConfigInput",
                "variableName": "staticViewInput"
              },
              {
                "kind": "Variable",
                "name": "viewId",
                "variableName": "viewId"
              },
              {
                "kind": "Variable",
                "name": "viewQueryInput",
                "variableName": "viewQueryInput"
              }
            ],
            "kind": "LinkedField",
            "name": "jiraIssueSearchView",
            "plural": false,
            "selections": [
              (v31/*: any*/),
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isJiraView"
              },
              {
                "concreteType": "QueryError",
                "kind": "LinkedField",
                "name": "error",
                "plural": false,
                "selections": (v33/*: any*/)
              },
              (v34/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "viewId"
                  },
                  {
                    "args": (v36/*: any*/),
                    "concreteType": "JiraIssueSearchFieldSetConnection",
                    "kind": "LinkedField",
                    "name": "fieldSets",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraIssueSearchFieldSetEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "JiraIssueSearchFieldSet",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v37/*: any*/),
                              {
                                "concreteType": "JiraFieldSetPreferences",
                                "kind": "LinkedField",
                                "name": "fieldSetPreferences",
                                "plural": false,
                                "selections": [
                                  {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisfrozencolumnsenabledrelayprovidertsx",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "isFrozen"
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraninlastusedjqlrelayprovider",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      (v38/*: any*/)
                    ]
                  },
                  {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewenabledrelayprovider",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "canPublishViewConfig"
                      },
                      (v39/*: any*/),
                      (v40/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "args": (v42/*: any*/),
                            "concreteType": "JiraIssueSearchViewConfigSettings",
                            "kind": "LinkedField",
                            "name": "viewSettings",
                            "plural": false,
                            "selections": [
                              (v44/*: any*/),
                              (v45/*: any*/),
                              (v46/*: any*/)
                            ]
                          }
                        ],
                        "type": "JiraSpreadsheetView",
                        "abstractKey": "__isJiraSpreadsheetView"
                      },
                      (v48/*: any*/)
                    ]
                  },
                  {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      (v39/*: any*/)
                    ]
                  }
                ],
                "type": "JiraIssueSearchViewMetadata",
                "abstractKey": "__isJiraIssueSearchViewMetadata"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "args": (v42/*: any*/),
                    "concreteType": "JiraIssueSearchViewConfigSettings",
                    "kind": "LinkedField",
                    "name": "viewSettings",
                    "plural": false,
                    "selections": [
                      (v49/*: any*/),
                      (v50/*: any*/),
                      (v44/*: any*/),
                      (v46/*: any*/),
                      (v45/*: any*/)
                    ]
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "args": [
                          (v35/*: any*/)
                        ],
                        "kind": "ScalarField",
                        "name": "hasDefaultFieldSets"
                      },
                      {
                        "args": (v36/*: any*/),
                        "concreteType": "JiraIssueSearchFieldSetConnection",
                        "kind": "LinkedField",
                        "name": "fieldSets",
                        "plural": false,
                        "selections": [
                          (v51/*: any*/),
                          {
                            "concreteType": "JiraIssueSearchFieldSetEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "JiraIssueSearchFieldSet",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "JiraFieldSetPreferences",
                                    "kind": "LinkedField",
                                    "name": "fieldSetPreferences",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "width"
                                      }
                                    ]
                                  },
                                  (v52/*: any*/),
                                  (v53/*: any*/),
                                  (v54/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "isSortable"
                                  },
                                  {
                                    "concreteType": "JiraFieldType",
                                    "kind": "LinkedField",
                                    "name": "fieldType",
                                    "plural": false,
                                    "selections": [
                                      (v53/*: any*/)
                                    ]
                                  },
                                  {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "aliases"
                                      }
                                    ]
                                  },
                                  {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                      {
                                        "concreteType": "JiraIssueSearchFieldMetadataConnection",
                                        "kind": "LinkedField",
                                        "name": "fieldsMetadata",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "JiraIssueSearchFieldMetadataEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "concreteType": "JiraIssueSearchMetadataField",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "canBeConfigured"
                                                  },
                                                  (v43/*: any*/)
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  {
                                    "kind": "ClientExtension",
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "isPlaceHolderField"
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          (v48/*: any*/)
                        ]
                      },
                      {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          (v40/*: any*/)
                        ]
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "args": (v42/*: any*/),
                            "concreteType": "JiraIssueSearchViewConfigSettings",
                            "kind": "LinkedField",
                            "name": "viewSettings",
                            "plural": false,
                            "selections": [
                              (v46/*: any*/),
                              (v55/*: any*/),
                              (v49/*: any*/),
                              (v50/*: any*/),
                              (v45/*: any*/),
                              (v44/*: any*/),
                              {
                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscissuerankingrelayprovider",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "canEnableReranking"
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "args": (v56/*: any*/),
                                "concreteType": "JiraFormattingRuleConnection",
                                "kind": "LinkedField",
                                "name": "conditionalFormattingRules",
                                "plural": false,
                                "selections": [
                                  {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewconditionalformattingenabledrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                      {
                                        "concreteType": "JiraFormattingRuleEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "concreteType": "JiraFormattingRule",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "kind": "LinkedField",
                                                "name": "expression",
                                                "plural": false,
                                                "selections": [
                                                  (v31/*: any*/),
                                                  (v58/*: any*/),
                                                  (v59/*: any*/),
                                                  (v60/*: any*/)
                                                ]
                                              },
                                              (v61/*: any*/),
                                              {
                                                "concreteType": "JiraColor",
                                                "kind": "LinkedField",
                                                "name": "formattingColor",
                                                "plural": false,
                                                "selections": [
                                                  (v34/*: any*/),
                                                  (v62/*: any*/)
                                                ]
                                              },
                                              (v34/*: any*/)
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ],
                                "storageKey": "conditionalFormattingRules(first:20)"
                              }
                            ]
                          }
                        ],
                        "type": "JiraSpreadsheetView",
                        "abstractKey": "__isJiraSpreadsheetView"
                      },
                      (v48/*: any*/)
                    ],
                    "type": "JiraIssueSearchViewMetadata",
                    "abstractKey": "__isJiraIssueSearchViewMetadata"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v38/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "filterId"
                          },
                          {
                            "args": (v42/*: any*/),
                            "concreteType": "JiraIssueSearchViewConfigSettings",
                            "kind": "LinkedField",
                            "name": "viewSettings",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "JiraSpreadsheetGroupByConfig",
                                "kind": "LinkedField",
                                "name": "groupByConfig",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "JiraField",
                                    "kind": "LinkedField",
                                    "name": "groupByField",
                                    "plural": false,
                                    "selections": [
                                      (v63/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "typeKey"
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ],
                        "type": "JiraSpreadsheetView",
                        "abstractKey": "__isJiraSpreadsheetView"
                      }
                    ],
                    "type": "JiraView",
                    "abstractKey": "__isJiraView"
                  },
                  {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcbulkopsselectallrelayprovider",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "args": (v42/*: any*/),
                        "concreteType": "JiraIssueSearchViewConfigSettings",
                        "kind": "LinkedField",
                        "name": "viewSettings",
                        "plural": false,
                        "selections": [
                          (v55/*: any*/)
                        ]
                      }
                    ]
                  },
                  {
                    "condition": "isSavedViewConditionalFormattingEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      (v39/*: any*/),
                      {
                        "args": (v56/*: any*/),
                        "concreteType": "JiraFormattingRuleConnection",
                        "kind": "LinkedField",
                        "name": "conditionalFormattingRules",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "JiraFormattingRuleEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "JiraFormattingRule",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v34/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "name": "expression",
                                    "plural": false,
                                    "selections": [
                                      (v31/*: any*/),
                                      (v59/*: any*/),
                                      (v58/*: any*/),
                                      (v60/*: any*/)
                                    ]
                                  },
                                  {
                                    "concreteType": "JiraColor",
                                    "kind": "LinkedField",
                                    "name": "formattingColor",
                                    "plural": false,
                                    "selections": (v64/*: any*/)
                                  },
                                  (v61/*: any*/)
                                ]
                              },
                              (v31/*: any*/)
                            ]
                          },
                          (v48/*: any*/)
                        ],
                        "storageKey": "conditionalFormattingRules(first:20)"
                      },
                      (v48/*: any*/)
                    ]
                  }
                ],
                "type": "JiraSpreadsheetView",
                "abstractKey": "__isJiraSpreadsheetView"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraninlastusedjqlrelayprovider",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      (v188/*: any*/),
                      {
                        "args": (v72/*: any*/),
                        "filters": (v189/*: any*/),
                        "handle": "connection",
                        "key": "IssueNavigatorJiraDetailedViewPagination__issues",
                        "kind": "LinkedHandle",
                        "name": "issues"
                      }
                    ]
                  },
                  {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraninlastusedjqlrelayprovider",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                      (v188/*: any*/),
                      {
                        "args": (v72/*: any*/),
                        "filters": (v190/*: any*/),
                        "handle": "connection",
                        "key": "IssueNavigatorDetailedViewPagination__issues",
                        "kind": "LinkedHandle",
                        "name": "issues"
                      }
                    ]
                  }
                ],
                "type": "JiraDetailedView"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraninlastusedjqlrelayprovider",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      (v197/*: any*/),
                      {
                        "args": (v191/*: any*/),
                        "filters": (v189/*: any*/),
                        "handle": "connection",
                        "key": "IssueNavigatorJiraGroupedListViewPagination__groups",
                        "kind": "LinkedHandle",
                        "name": "groups"
                      }
                    ]
                  },
                  {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraninlastusedjqlrelayprovider",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                      (v197/*: any*/),
                      {
                        "args": (v191/*: any*/),
                        "filters": (v190/*: any*/),
                        "handle": "connection",
                        "key": "IssueNavigatorGroupedListViewPagination__groups",
                        "kind": "LinkedHandle",
                        "name": "groups"
                      }
                    ]
                  }
                ],
                "type": "JiraGroupedListView"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraninlastusedjqlrelayprovider",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      (v199/*: any*/),
                      {
                        "args": (v198/*: any*/),
                        "filters": (v189/*: any*/),
                        "handle": "connection",
                        "key": "IssueNavigatorJiraListViewPagination__issues",
                        "kind": "LinkedHandle",
                        "name": "issues"
                      }
                    ]
                  },
                  {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraninlastusedjqlrelayprovider",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                      (v199/*: any*/),
                      {
                        "args": (v198/*: any*/),
                        "filters": (v190/*: any*/),
                        "handle": "connection",
                        "key": "IssueNavigatorListViewPagination__issues",
                        "kind": "LinkedHandle",
                        "name": "issues"
                      }
                    ]
                  }
                ],
                "type": "JiraListView"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "657fd074c1c93880ebe66cca5e694d582648431d67a2ff5a78fab6939e92c8f9",
    "metadata": {},
    "name": "IssueNavigatorIssueSearchRefetchQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "isLastUsedJqlEnabled": isLastUsedJqlEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraninlastusedjqlrelayprovider": lastUsedJql_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider": isSavedListViewTechnicalChangesEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcisfrozencolumnsenabledrelayprovidertsx": isFrozenColumnsEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcbulkopsselectallrelayprovider": isBulkOpsSelectAllEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewenabledrelayprovider": isSavedListViewEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjscissuerankingrelayprovider": isIssueRankingEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider": isJscIFCEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider": isJSCAliasChangesEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewconditionalformattingenabledrelayprovider": isSavedViewConditionalFormattingEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider": isReparentingEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcfrontierformulafieldd1relayprovider": isFormulaFieldD1Enabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcinitialisevirtualiserstatefromrelaystorerelayprovider": isInitialiseVirtualiserStateFromRelayStoreEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcmimicflatlistrsswhileuninitialisedrelayprovider": isMimicFlatlistRssWhileUninitialisedEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreducererendersrelayprovider": isJiraListReduceRerendersEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider": isJscMergedColumnEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider": isJiraItrM4Exp3Enabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider": isIframePreviewPanelInSubtasksEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider": isJiraTimelineAnalyticsHarmonizationEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider": isAtlasProjectEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider": originalEstimateEditableFixFlag_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider": isFieldsByIdRemoved_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaifetchapptypeforuserassigneerelayprovider": shouldFetchAppUserType_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider": isJiraAiAgentAvatarSingleUserPickerEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider": isNinStrikethroughResolutionUpdateEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": isNumberFieldConfigurableEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider": isPlaceholderDataEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider": isJiraConfluencePageContentEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider": isJiraTimelineRollupsTechnicalGateEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerninrelayprovider": isJiraAiAgentAvatarSingleUserPickerNINEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyprojectsrelayprovider": isGroupByProjectsEnabled_provider
    }
  }
};
})();

(node as any).hash = "18fab3472fda4fc5644bb1ff3ecfb481";

export default node;
